import PropTypes from 'prop-types';
import sanitizer from 'sanitizer';

import Sort from 'components/search/Sort';
import { retrieveH1TagFromFilters } from 'helpers/SeoOptimizedDataHelper';
import marketplace from 'cfg/marketplace.json';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';

import css from 'styles/components/search/desktopSearchHeader.scss';

const {
  search: { hasSelectSort, sortOptions }
} = marketplace;

export const DesktopSearchHeader = ({ totalProductCount, onSortSelected, filters, makePersonalizedExperience }, { testId }) => (
  <div className={css.desktopSearchHeader}>
    <div className={css.countWrapper}>
      <h1 className={css.fullCount} dangerouslySetInnerHTML={{ __html: sanitizer.sanitize(retrieveH1TagFromFilters(filters)) }} data-test-id={testId('desktopSearchResultsText')}/>
      <span className={css.shortCount} data-test-id={testId('searchResultsItemCount')}>
        {!!totalProductCount && `${totalProductCount} items found`}
      </span>
    </div>
    {hasSelectSort && <span className={css.sortWrapper} data-test-id={testId('desktopSearchSort')}>
      <Sort
        tabIndex={0}
        sortOptions={sortOptions}
        onSortSelected={onSortSelected}
        selectedSort={filters.sort}
        filters={filters}
        testId={testId('selectSortValue')} />
      {makePersonalizedExperience && makePersonalizedExperience()}
    </span>}
  </div>
);

DesktopSearchHeader.displayName = 'DesktopSearchHeader';
DesktopSearchHeader.contextTypes = {
  testId: PropTypes.func
};

export default withErrorBoundary('DesktopSearchHeader', DesktopSearchHeader);
